<script setup lang="ts">
import { computed, ref, watch } from 'vue'
// `useRoute` auto-importé de Nuxt, pas celui de vue-router : il ne bascule qu'une fois la nouvelle page affichée,
// sinon la sidebar change avant que la page sortante ait laissé place à la suivante
import SidebarMobile from '~/components/layout/sidebar/SidebarMobile.vue'

// Écran d'un bien, en création (`/annonces/creer`) comme en modification (`/annonces/:id`) : plein écran avec le menu
// des sections (BienEditor), sans la sidebar de recherche de biens ni le pied de page
const ECRAN_BIEN_RE = /^\/annonces\/[^/]+$/

const sidebarOpen = ref(false)
const route = useRoute()

const useTimelineLayout = computed(() => ECRAN_BIEN_RE.test(route.path))
const showSidebar = computed(() => !useTimelineLayout.value)

// Zone de contenu défilante (écrans xl) : conservée d'une page à l'autre par le layout, elle est remise en haut
// à chaque navigation, comme Nuxt le fait pour la fenêtre
const contentArea = ref<HTMLElement>()
watch(() => route.path, () => {
  contentArea.value?.scrollTo({ top: 0 })
})
</script>

<template>
  <div>
    <SidebarMobile
      :sidebar-open="sidebarOpen"
      @close-sidebar="sidebarOpen = false"
    />

    <div class="fixed top-0 left-0 right-0 z-50 w-full border-b-1.5 border-pink-900">
      <Header @open-sidebar="sidebarOpen = true" />
    </div>

    <div
      v-if="useTimelineLayout"
      class="pt-16 h-screen"
    >
      <Main class="h-full">
        <slot />
      </Main>
    </div>
    <!-- Écrans xl : sidebar fixe sur toute la hauteur, contenu et pied de page dans une zone qui défile seule -->
    <div
      v-else
      class="pt-16 xl:flex xl:h-screen"
    >
      <div
        v-if="showSidebar"
        class="hidden xl:flex xl:flex-col xl:shrink-0"
      >
        <Sidebar />
      </div>

      <!-- Colonne d'au moins la hauteur de l'écran (sous le header) dont `Main` prend la place libre : le pied de page reste en bas même sur une page courte -->
      <div ref="contentArea" class="flex flex-col flex-1 min-w-0 min-h-[calc(100dvh-4rem)] pt-8 px-6 sm:px-8 xl:pr-10 xl:overflow-y-auto">
        <Main class="flex-1">
          <slot />
        </Main>
        <Footer class="mt-16" />
      </div>
    </div>
  </div>
</template>
